// AI Generated Test
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { ChangesHistoryReadabilityService } from '@client/app/pages/global/changes-history/services/readability/readability.service';

@Component({
    selector: 'changes-history-dashboard-table-readability',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-48">
                <table class="table table-hover table-fixed">
                    <thead>
                    <tr>
                        <th class="col-22 col-lg-23">
                            {{'Crawled at' | translate}}
                        </th>
                        <th class="text-right col-4 col-lg-8">
                            <span class="visible-print-block">{{'Pages' | translate}}</span>
                            <span class="hidden-print">{{'Pages crawled' | translate}}</span>
                        </th>
                        <th class="text-right col-22 col-lg-16">
                            <span class="visible-print-block">{{'Levels' | translate}}</span>
                            <span class="hidden-print">{{'Readability levels' | translate}}</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let story of historyOutput; trackBy: trackById">
                        <td class="text-v-middle">
                            <user-date [twoLines]="true"
                                       [date]="story.post_processing_done_at || story.date">
                            </user-date>
                        </td>
                        <td class="text-v-middle text-right">
                            {{story.page_count + story.documents_count | monNumber}}
                        </td>
                        <td class="text-v-middle text-right">
                            <span class="mr-1"
                                  *ngFor="let level of readabilityLevels; trackBy: trackByIndex"
                                  [ngbTooltip]="tooltipTemplate"
                                  triggers="focus hover"
                                  [tooltipClass]="'text-ellipsis'">
                                <span class="fas fa-circle" [ngStyle]="{color: level.color}">
                                </span>
                                <span>{{story.levels[level.attr]}}</span>

                                <ng-template #tooltipTemplate>
                                    <div>
                                        <span class="mr-1 fas fa-square" [ngStyle]="{color: level.color}"></span>
                                        <span>{{level.label}}</span>
                                    </div>
                                </ng-template>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `,
})
export class ReadabilityTableComponent implements OnInit, OnChanges {
    @Input() history: any;
    @Input() domain: any;

    historyOutput: any[] = [];
    readabilityLevels: any[] = [];

    constructor (
        private pipeService: PipeService,
        private changesHistoryReadabilityService: ChangesHistoryReadabilityService,
    ) {}

    ngOnInit (): void {
        this.getReadabilityLevels();
    }

    ngOnChanges (changes: any): void {
        this.getReadabilityLevels();

        if (changes.history) {
            this.historyOutput = this.prepareHistoryOutput(this.history);
            this.historyOutput.sort((a: any, b: any) => {
                return b.id - a.id;
            });
        }
    }

    trackById (index: number, item: any): any {
        return item.id;
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    private prepareHistoryOutput (history: any): any[] {
        const result: any[] = [];
        const len = history.length;
        let story: any;
        let entry: any;

        // for is faster than map
        for (let i = 0; i < len; i += 1) {
            story = history[i];
            entry = {
                id: story.id,
                post_processing_done_at: story.post_processing_done_at,
                date: story.date,
                page_count: story.page_count,
                documents_count: story.documents_count,
                levels: {},
            };

            this.readabilityLevels.forEach((level: any) => {
                entry.levels[level.attr] = this.pipeService.get('monNumber')(this.getReadabilityLevelDistributeValue(story, level.attr));
            });

            result.push(entry);
        }

        return result;
    }

    private getReadabilityLevels (): void {
        this.readabilityLevels = this.changesHistoryReadabilityService.getReadabilityLevels(this.domain.features.readability_test);
    }

    private getReadabilityLevelDistributeValue (story: any, attr: string): number {
        if (story.readability_distribution) {
            return story.readability_distribution[attr] || 0;
        }
        return 0;
    }
}
